import axios from 'axios';

export default {
  getByCode: function (formulaCode) {
    return axios.get(`/api/ferformula/formulabycode/${formulaCode}`);
  },
  update: function (data) {
    return axios.post('/api/ferformula/updateformula', data);
  },
};
